// extracted by css-extract-rspack-plugin
module.exports =  {"loadebleComponent":"hCCvr","smallSize":"iJMXQ","noBg":"j8QtG"};